import { Grid, Typography, Box, Divider, Link, useMediaQuery } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import React, { Fragment } from "react";
import CCTechLogo from "../../asset/CCTech white.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  // const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const links = [
    {
      label: "About Us",
      route: "/about-us",
    },
    {
      label: "Contact Us",
      route: "/contact-us",
    },
    {
      label: "Terms and Conditions",
      route: "/terms-and-conditions",
    },
    {
      label: "Privacy Policy",
      route: "/privacy-policy",
    },
    {
      label: "Refund Policy",
      route: "/refunds",
    },
  ];

  const navigate = useNavigate();

  const handleLinkClick = (to) => {
    navigate(to);
    window.scrollTo(0, 0);
  };

  return (    
    <Fragment>
      <div style={{ position: "relative", minHeight: isSmallScreen ? "130vh" : "80vh" }}>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
          }}
        >
          <Divider />
          <Grid
            container
            sx={{ p: 10 }}
            justifyContent="space-between"
            spacing={4}
          >
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={{ pb: 2 }} variant="subtitle1">
                CALL
              </Typography>
              <Typography variant="subtitle1">(+91) 74474 77868</Typography>
              <br />
              <br />
              {links.map((link) => (
                <Typography
                  color="textSecondary"
                  onClick={() => handleLinkClick(link.route)}
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    padding: "2px 0",
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={{ pb: 2 }} variant="subtitle1">
                EMAIL
              </Typography>
              <Typography variant="subtitle1">info@cctech.co.in</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={{ pb: 2 }} variant="subtitle1">
                VISIT
              </Typography>
              <Typography variant="subtitle1">
                403, Pushpak Business Hub, Wakad, Pune 411057, India
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography sx={{ pb: 2 }} variant="subtitle1">
                FOLLOW US
              </Typography>
              <Link
                href="https://www.linkedin.com/company/centre-for-compuational-technologies-cctech"
                target="_blank"
                style={{ color: "white" }}
              >
                <LinkedInIcon />
              </Link>
            </Grid>
          </Grid>
          <Divider />
          <br />
          <Box sx={{ display: "flex", justifyContent: "center", pb: 5 }}>
            <Typography textAlign={"center"} variant="subtitle1">
              © 2006 - {currentYear} Copyright Centre for Computational
              Technologies Pvt. Ltd. All rights reserved{" "}
              <img src={CCTechLogo} alt="cctech logo" width={50} />
            </Typography>
          </Box>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
